import { practiceFeatures } from "../config/practice";

// Communication page tabs. Ids are fixed (selectedTab === 2 is always Voice
// mail), so a practice without some tabs just skips them. Fax is each
// practice's own RingCentral line (features.fax: 9928 and 7825). Email / Voice
// mail are C-HIM's mailbox and voicemail extensions, and Appt Requests its
// high-bp.com leads: 9928 only. 7825's page is Fax + Messaging.
export const ALL_COMMUNICATION_TABS = [
  { id: 0, label: "Fax", width: 64, feature: "fax" },
  { id: 1, label: "Email", width: 44, feature: "chimCommunication" },
  { id: 2, label: "Voice mail", width: 64, feature: "chimCommunication" },
  { id: 3, label: "Messaging", width: 74 },
  { id: 4, label: "Appt Requests", width: 100, feature: "websiteLeads" },
];

export function communicationTabs(features = practiceFeatures()) {
  return ALL_COMMUNICATION_TABS.filter((t) => !t.feature || features[t.feature]);
}
